import { attr, belongsTo } from '@warp-drive/legacy/model';

import Model from 'umg-ember-backend/models/mlp-module';
import { buildValidations } from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({});

export const settings = {
  copyableOptions: {
    ignoreAttributes: ['contentItem', 'dotDigitalCampaignId'],
  },
};

export default class MlpDownloadLinkFormModel extends Model.extend(
  Validations,
) {
  @belongsTo('asset', { async: true, inverse: null }) asset;
  @attr('string') emailSenderName;
  @attr('string') emailLogoImage;
  @attr('string') emailTeaserImage;
  @attr('string') dotDigitalCampaignId;
  @attr('string') campaign;
  @belongsTo('newsletter-target', { async: true, inverse: null })
  newsletterTarget;

  get displayHeadline() {
    return this.emailSenderName || 'Download Link Form';
  }

  get displayLabel() {
    return this.displayHeadline;
  }
}
